import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { AddressModel } from 'src/app/model/address.model';
import { AddressService } from 'src/app/service/address.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent extends DynamicItem implements OnInit {

  addressAttr: AttributeModel
  addressFields: AttributeModel[] = []
  addressModel: AddressModel
  zipCodeMask: string
  enableEditButton = false;
  isVisible = true;

  constructor(private addressService: AddressService) {
    super();
  }

  get hasCompanyParent(): boolean {
    return this.parent && this.parent.type.toUpperCase() === 'COMPANY'
  }

  ngOnInit() {
    let isRequiredOpt = this.attribute.options
        .find(opt => opt.key.toLowerCase() == "required" &&
                     opt.value.toLowerCase() == "true")

    if(isRequiredOpt) {
      this.addToEnvOptions(isRequiredOpt)
    }

    this.addressAttr = this.attribute.attributes
      .find(attr => attr.options.some(opt => opt.key.toLowerCase() == "integrationfield" &&
                                             opt.value.toLowerCase() == "zipcode"))

    if(this.addressAttr) {
      this.addressFields = this.attribute.attributes
        .filter(attr => attr.key != this.addressAttr.key)

      this.zipCodeMask = this.getZipCodeMask()
    }

    this.checkParentIsCompany();
    this.updateValueAddress();
  }

  checkParentIsCompany() {
    if(this.hasCompanyParent) {
      this.enableEditButton = true;
      this.isVisible = false;
     }
  }

  private getIntegrationField(integrationFieldName: string): AttributeModel {
    return this.attribute.attributes
      .find(e => e.options.some(opt => opt.key.toLowerCase() == "integrationfield" && 
                                       opt.value.toLowerCase() == integrationFieldName));
  }

  updateValueAddress() {
    let newAddress = "";
    let address = this.getIntegrationField("address");
    let number = this.getIntegrationField("number");
    let complement = this.getIntegrationField("complement");
    let neighborhood = this.getIntegrationField("neighborhood");
    let city = this.getIntegrationField("city");
    let state = this.getIntegrationField("state");
    let zipcode = this.getIntegrationField("zipcode");

    if(address && address.value) newAddress += address.value;
    if(number && number.value) newAddress += ', ' + number.value;
    if(complement && complement.value) newAddress += ', ' + complement.value;
    if(neighborhood && neighborhood.value) newAddress += ' - ' + neighborhood.value;
    if(city && city.value) newAddress += ' - ' + city.value;
    if(state && state.value) newAddress += ' - ' + state.value;
    if(zipcode && zipcode.value) newAddress += ' - ' + zipcode.value;

    this.attribute.value = newAddress;
  }

  getZipCodeMask(): string {
    if (!this.addressAttr.options) {
      return "";
    }

    let opt = this.addressAttr.options
        .find(option => option.key.toLowerCase() == "mask");

    if (opt) {
      return opt.value;
    }
    else {
      return "";
    }
  }

  onValueChange(addressAttr: AttributeModel, value: string) {
    let integrationFieldOpt = addressAttr.options
      .find(opt => opt.key.toLowerCase() == "integrationfield")

    if(integrationFieldOpt.value &&
        integrationFieldOpt.value.toLowerCase() == "zipcode" &&
        this.zipCodeMask.length == value.length && 
        !this.hasCompanyParent) {
      this.getAddressData()
    } else {
      this.updateValueAddress()
    }
  }

  private getAddressData() {
    let errorMessage = this.getZipCodeErrorMessage()

    if(this.addressAttr != null && this.addressAttr.value) {
      Swal.showLoading()

      this.addressService
        .getBy(this.addressAttr.value)
        .subscribe((addressModel: AddressModel) => {
          Swal.close()
          if(addressModel.address) {
            this.addressModel = addressModel
            this.loadAddressData()
            this.updateValueAddress()
          } else {
            this.addressModel = null
            Swal.fire("Atenção", errorMessage, "error")
          }
          this.emit({name: "autosave"})
        }, () => {
          this.addressModel = null
          Swal.fire("Atenção", errorMessage, "error")
        })
    }
  }

  private getZipCodeErrorMessage(): string  {
    let errorMessage = ""

    if(!this.addressAttr) {
      return errorMessage
    }

    let errorOpt = this.addressAttr.options
      .find(opt => opt.key.toLowerCase() == "errornotfound")

    if(errorOpt) {
      errorMessage = errorOpt.value
    } else {
      errorMessage = "O CEP digitado não foi encontrado"
    }

    return errorMessage
  }

  private loadAddressData() {
    this.addressFields.forEach(attr => {
      let integrationField = attr.options
        .find(opt => opt.key.toLowerCase() == "integrationfield")?.value

      if(!integrationField) {
        integrationField = attr.key.toLowerCase()
      }

      attr.value = this.addressModel[integrationField]
    })
  }
}
